import * as React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker'
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker'
import { TimeStepOptions, TimeView } from '@mui/x-date-pickers/models'
import { theme } from './theme'
import { TimeIcon } from '../icons'

export interface TimePickerProps {
  value: Date | null | undefined
  onChange: (date: Date, context?: any) => void
  format?: string
  placeholder?: string
  ampm?: boolean
  disabled?: boolean
  closeOnSelect?: boolean
  views?: TimeView[]
  onError?: (errorType: string) => void
  slotProps?: any
  slots?: object
  timeSteps?: TimeStepOptions
  minTime?: Date
  maxTime?: Date
}

const timePicker =
  (keyboard = false): React.FC<TimePickerProps> =>
  ({
    value,
    onChange,
    format = 'HH:mm',
    placeholder = 'Time',
    ampm = false,
    disabled = false,
    closeOnSelect = true,
    views = ['hours', 'minutes'],
    onError,
    slots = {},
    slotProps = {},
    timeSteps,
    minTime,
    maxTime,
  }) => {
    const Component = keyboard ? DesktopTimePicker : MobileTimePicker
    const props = {
      value,
      format,
      ampm,
      placeholder,
      disabled,
      closeOnSelect,
      views,
      onChange,
      onError,
      timeSteps,
      minTime,
      maxTime,
      slots: {
        ...slots,
        openPickerIcon: TimeIcon,
      },
      slotProps: {
        ...slotProps,
        textField: {
          ...slotProps.textField,
          InputLabelProps: { shrink: false },
          inputProps: { placeholder },
          size: 'small',
        },
      },
    }

    return (
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Component {...props} />
        </LocalizationProvider>
      </ThemeProvider>
    )
  }

export const TimePicker = timePicker()
export const KeyboardTimePicker = timePicker(true)
